import axios from "axios";
import { Modal, Spinner } from "react-bootstrap"
import { useMutation, useQuery } from "react-query"
import { DEV_SERVER } from "../../../constants/urls";
import { userSignal } from "../../../signal/userSignal";
import { toast } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import { Tree, TreeNode } from 'react-organizational-chart';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { ReactInfiniteCanvas, ReactInfiniteCanvasHandle } from "react-infinite-canvas";
import { myGrpsSignal } from "../../../signal/myGrpsSIgnals";

export default function GroupModal(props) {
    const [groups, setGroups] = useState({})
    const [selectedNode, setSelectedNode] = useState(null)
    const [showEditNameModal, setShowEditNameModal] = useState(false)
    const canvasRef = useRef();

    const getGroups = useQuery("groups", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/groups/v2`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setGroups(data?.data)

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const getMyGrps = useQuery("myGrps", async () => {
        const response = await axios.get(`${DEV_SERVER}/groups/v2/myGrps`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            }
        })
        return response.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                myGrpsSignal.value = data.data
            }
        },
        onError: (error) => {
            console.log(error);
        }
    })

    const refetchGroups = () => {
        getGroups.refetch()
    }

    const TreeView = ({ data, path }) => {
        if (data?.children && data?.children?.length > 0) {
            return (
                <TreeNode label={<Node name={data?.name} path={path + data?.name + "/"} />}>
                    {data?.children.map((child) => {
                        return <TreeView data={child} path={path + data?.name + "/"} />
                    })}
                </TreeNode>
            )
        } else {
            return (
                <TreeNode label={<Node name={data?.name} path={path + data?.name + "/"} />} />
            )
        }
    }

    const Node = ({ name, path }) => {

        const [isHover, setIsHover] = useState(false)

        return (
            <span className="p-2" onMouseOver={() => setIsHover(true)} onMouseOut={() => setIsHover(false)} style={{ border: "1px solid #096DD9", borderRadius: "10px", position: "relative", fontSize: "2rem", cursor: "pointer", whiteSpace: "nowrap" }}>

                <span style={{ visibility: isHover ? "hidden" : "visible" }}>{name}</span>

                {isHover &&
                    <div className="d-flex flex-wrap justify-content-center align-items-center" style={{ position: "absolute", top: '0%', left: "0%", zIndex: "2000", width: "100%", height: "100%", columnGap: '0.3rem' }}>
                        <i className="fa fa-plus-circle" style={{ fontSize: "0.8rem", color: "#096DD9", cursor: "pointer" }} onClick={() => addChildren(path)}></i>
                        {path !== "/" && <i className="fa fa-edit" style={{ fontSize: "0.8rem", color: "#096DD9", cursor: "pointer" }}
                            onClick={() => {
                                setSelectedNode({ path: path, name: name })
                                setShowEditNameModal(true)
                            }}
                        ></i>}
                        {path !== "/" && <i className="fa fa-trash" style={{ fontSize: "0.8rem", color: "#096DD9", cursor: "pointer" }} onClick={() => deleteGrp(path)}></i>}
                    </div>
                }
            </span>
        )
    }

    const addChildren = (path) => {
        let _grps = { ...groups }
        let temp = _grps?.children || []
        let _path = path.split("/")

        let parent = null
        let parentChilds = temp

        for (let i = 1; i < _path.length - 1; i++) {
            parent = parentChilds.find((child) => child?.name === _path[i])
            if (parent && !parent?.children) {
                parent.children = []
            }
            parentChilds = parent?.children || []
        }

        console.log("parent ", parent)
        console.log("parentChilds ", parentChilds)

        if (parent) {
            parentChilds.push({
                name: parent?.name + "." + (parentChilds?.length || "0"),
                children: []
            })
        } else {
            temp.push({
                name: "New Grp" + (temp?.length ? " " + temp?.length : ""),
                children: []
            })
        }

        _grps.children = temp

        setGroups(_grps)
    }

    const editGrp = (path, oldName, newName) => {
        let _grps = { ...groups }
        let temp = _grps?.children || []
        let _path = path.split("/")

        let parent = null
        let parentChilds = temp

        for (let i = 1; i < _path.length - 1; i++) {
            parent = parentChilds.find((child) => child?.name === _path[i])
            parentChilds = parent?.children || []
        }

        if (parent) {
            parent.name = newName
        } else {
            _grps.name = newName
        }

        _grps.children = temp

        setGroups(_grps)
    }

    const deleteGrp = (path) => {
        let _grps = { ...groups }
        let temp = _grps?.children || []
        let _path = path.split("/")

        let parentParent = _grps
        let parent = null
        let parentChilds = temp

        for (let i = 1; i < _path.length - 1; i++) {
            if (parent) {
                parentParent = parent
            }
            parent = parentChilds.find((child) => child?.name === _path[i])
            parentChilds = parent?.children || []
        }

        console.log("parent ", parent)
        console.log("parentParent ", parentParent)
        console.log("parentChilds ", parentChilds)

        if (parent && parentParent) {
            parentParent.children = parentParent.children.filter((child) => child?.name !== parent?.name)
        }

        setGroups(_grps)
    }

    const updateGrps = useMutation((data) => axios.put(`${DEV_SERVER}/groups/v2`, data, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        }
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success("Groups updated successfully")
                getMyGrps.refetch({cancelRefetch: true})
                props?.close()
            } else {
                toast.error(data.data.message)
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error("Something went wrong")
            }
        }
    })

    useEffect(() => {
        refetchGroups()
    }, [])

    const EditNameModal = ({ path, oldName }) => {
        const [newName, setNewName] = useState(oldName)

        const handleEdit = (e) => {
            e.preventDefault()
            editGrp(path, oldName, newName)
            setShowEditNameModal(false)
        }

        return (
            <Modal show={showEditNameModal} onHide={() => setShowEditNameModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Name</Modal.Title>
                </Modal.Header>

                <form onSubmit={(e) => handleEdit(e)}>
                <Modal.Body>
                    <input type="text" className="form-control" autoFocus value={newName} onChange={(e) => setNewName(e.target.value)} />
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-primary" type="submit">Edit</button>
                </Modal.Footer>
                </form>
            </Modal>
        )
    }

    const handleSubmit = () => {
        updateGrps.mutate(groups)
    }

    return (
        <Modal fullscreen show={props?.show} onHide={() => props?.close()}>
            <Modal.Header closeButton>
                <Modal.Title>Groups</Modal.Title>
            </Modal.Header>

            <Modal.Body className="w-100 h-100">

                {(getGroups.isLoading || getGroups.isFetching) ?
                    (
                        <div className="d-flex justify-content-center align-items-center">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    )
                    :
                    (
                        <div className="w-100 h-100">

                            <ReactInfiniteCanvas
                                ref={canvasRef}
                                onCanvasMount={(mountFunc) => {
                                    mountFunc.fitContentToView({ scale: 1 });
                                }}
                                customComponents={[
                                    {
                                        component: (
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => {
                                                    canvasRef.current?.fitContentToView({ scale: 1 });
                                                }}
                                            >
                                                fitToView
                                            </button>
                                        ),
                                        position: "top-left",
                                        offset: { x: 60, y: 0 },
                                    },
                                ]}
                            >
                                <Tree label={<Node name={groups?.name} path="/" />} lineBorderRadius="10px" lineHeight="90px" nodePadding="20px">
                                    {groups?.children?.map((child) => {
                                        return <TreeView data={child} path={"/"} />
                                    })}
                                </Tree>
                            </ReactInfiniteCanvas>
                        </div>
                    )
                }

            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-secondary" onClick={() => props?.close()}>Close</button>
                <button className="btn btn-primary" onClick={() => handleSubmit()} disabled={updateGrps.isLoading}>
                    {updateGrps.isLoading ? "Updating..." : "Update"}
                </button>
            </Modal.Footer>


            {showEditNameModal && <EditNameModal path={selectedNode?.path} oldName={selectedNode?.name} />}

        </Modal>
    )
}